<p class=" text-first">
    {{description | slice:sliceOptions.start:sliceOptions.end}}
    <a (click)="onToggleText()"></a>
</p>